import eventClient from "@/api/central/events"

// state
const state = {
    event: {}
};

// getters
const getters = {

};

// actions
const actions = {
    fetch({ commit }, id) {
        return eventClient
            .show(id)
            .then(({ data }) => commit('setEvent', data.data))
    },
    refresh({ dispatch, state }) {
        /**
         * Refresh is mostly called when there is something deleted. 
         * If a new event is created refresh can not be executed because the event does not exists.
         */

        return state.event.id
            ? dispatch('fetch', state.event.id)
            : Promise.resolve()
    }
};

// mutations
const mutations = {
    setEvent(state, event) {
        state.event = event;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
